import { EUserRoles } from '@enums/common';

type TPartialUserRolesKeys = Partial<keyof typeof EUserRoles>;

export const adminGroupAccess: TPartialUserRolesKeys[] = [
	'assetOwnerOrganizationAdministrator',
	'assetOwnerContact',
	'assetOwnerDefaultContact',
	'assetOwnerViewer',
	'assetOwnerAttributeUpdater',
	'assetOwnerSignatory',
	'assetOwnerManageRequests',
	'assetOwnerApprovalUnit',
	'networkOperatorOrganizationAdministrator',
	'assetConsumerOrganizationAdministrator',
	'networkOperatorAssetEnquirer',
	'assetConsumerAssetEnquirer',
	'networkOperatorTelecomSitesViewer',
	'networkOperatorTelecomSitesAttributeUpdater',
	'networkOperatorKpiViewer',
	'networkOperatorKpiUpdater',
	'networkOperatorThresholdKpiViewer',
	'networkOperatorThresholdKpiUpdater',
	'platformOwnerAdministrator',
	'networkOperatorAlarmManager',
	'networkOperatorCmModuleEditor',
	'networkOperatorCmModuleViewer',
	'portalOwner',
	'portalProjectMember',
	'portalProjectAdministrator',
	'smoLightViewer',
	'smoLightUpdater',
	'networkOperatorCmModuleAdmin',
];

export const mapGroupAccess: TPartialUserRolesKeys[] = [
	'assetOwnerContact',
	'assetOwnerDefaultContact',
	'assetOwnerViewer',
	'assetOwnerAttributeUpdater',
	'assetOwnerSignatory',
	'assetOwnerManageRequests',
	'assetOwnerApprovalUnit',
	'networkOperatorAssetEnquirer',
	'assetConsumerAssetEnquirer',
	'networkOperatorAssetViewer',
	'assetConsumerAssetViewer',
	'networkOperatorTelecomSitesViewer',
	'networkOperatorTelecomSitesAttributeUpdater',
	'networkOperatorKpiViewer',
	'networkOperatorKpiUpdater',
];

export const cmModuleGroupAccess: TPartialUserRolesKeys[] = [
	'networkOperatorCmModuleEditor',
	'networkOperatorCmModuleViewer',
	'networkOperatorCmModuleAdmin',
];

export const manageNetworkElementConfigurationAccess: TPartialUserRolesKeys[] = [
	'networkOperatorCmModuleEditor',
	'networkOperatorCmModuleViewer',
	'networkOperatorCmModuleAdmin',
];

export const configurationDataModelManagementGroupAccess: TPartialUserRolesKeys[] = [
	'networkOperatorCmModuleEditor',
	'networkOperatorCmModuleViewer',
	'networkOperatorCmModuleAdmin',
];

export const configurationTemplatesGroupAccess: TPartialUserRolesKeys[] = [
	'networkOperatorCmModuleEditor',
	'networkOperatorCmModuleViewer',
	'networkOperatorCmModuleAdmin',
];

export const operationRulesGroupAccess: TPartialUserRolesKeys[] = [
	'networkOperatorCmModuleEditor',
	'networkOperatorCmModuleViewer',
	'networkOperatorCmModuleAdmin',
];

export const chocolateMenuGroupAccess: TPartialUserRolesKeys[] = [
	'assetOwnerOrganizationAdministrator',
	'networkOperatorOrganizationAdministrator',
	'networkOperatorThresholdKpiViewer',
	'networkOperatorThresholdKpiUpdater',
	'networkOperatorCmModuleViewer',
	'networkOperatorCmModuleEditor',
	'networkOperatorCmModuleAdmin',
	'networkOperatorAlarmManager',
	'smoLightViewer',
	'smoLightUpdater',
	'assetConsumerOrganizationAdministrator',
	'portalProjectAdministrator',
	'portalProjectMember',
	'networkOperatorAssetViewer',
	'assetConsumerAssetViewer',
	'assetOwnerContact',
	'assetOwnerDefaultContact',
	'assetOwnerViewer',
	'assetOwnerAttributeUpdater',
	'assetOwnerSignatory',
	'assetOwnerManageRequests',
	'assetOwnerApprovalUnit',
	'networkOperatorAssetEnquirer',
	'networkOperatorTelecomSitesViewer',
	'networkOperatorTelecomSitesAttributeUpdater',
	'networkOperatorKpiViewer',
	'networkOperatorKpiUpdater',
	'assetConsumerAssetEnquirer',
];

export const menuGroupAccessAdminPanelOnly: TPartialUserRolesKeys[] = [
	'assetOwnerOrganizationAdministrator',
	'networkOperatorOrganizationAdministrator',
	'networkOperatorThresholdKpiViewer',
	'networkOperatorThresholdKpiUpdater',
	'networkOperatorCmModuleViewer',
	'networkOperatorCmModuleEditor',
	'networkOperatorCmModuleAdmin',
	'networkOperatorAlarmManager',
	'smoLightViewer',
	'smoLightUpdater',
	'assetConsumerOrganizationAdministrator',
	'portalProjectAdministrator',
	'portalProjectMember',
];

export const menuGroupAccessMapOnly: TPartialUserRolesKeys[] = [
	'networkOperatorAssetViewer',
	'assetConsumerAssetViewer',
];

export const menuGroupAccessBoth: TPartialUserRolesKeys[] = [
	'assetOwnerContact',
	'assetOwnerDefaultContact',
	'assetOwnerViewer',
	'assetOwnerAttributeUpdater',
	'assetOwnerSignatory',
	'assetOwnerManageRequests',
	'assetOwnerApprovalUnit',
	'networkOperatorAssetEnquirer',
	'networkOperatorTelecomSitesViewer',
	'networkOperatorTelecomSitesAttributeUpdater',
	'networkOperatorKpiViewer',
	'networkOperatorKpiUpdater',
	'assetConsumerAssetEnquirer',
];

export const userProfileGroupAccess: TPartialUserRolesKeys[] = [
	'defaultRole',
	'platformOwnerAdministrator',
	'portalOwner',
	'portalProjectAdministrator',
	'portalProjectMember',
	'assetOwnerOrganizationAdministrator',
	'assetOwnerApprovalUnit',
	'assetOwnerDefaultContact',
	'assetOwnerContact',
	'assetOwnerViewer',
	'assetOwnerAttributeUpdater',
	'assetOwnerSignatory',
	'assetOwnerManageRequests',
	'assetConsumerOrganizationAdministrator',
	'assetConsumerAssetEnquirer',
	'assetConsumerAssetViewer',
	'networkOperatorOrganizationAdministrator',
	'networkOperatorAssetEnquirer',
	'networkOperatorAssetViewer',
	'networkOperatorTelecomSitesViewer',
	'networkOperatorTelecomSitesAttributeUpdater',
	'networkOperatorKpiViewer',
	'networkOperatorThresholdKpiViewer',
	'networkOperatorKpiUpdater',
	'networkOperatorThresholdKpiUpdater',
	'networkOperatorCmModuleEditor',
	'networkOperatorCmModuleViewer',
	'networkOperatorCmModuleUpdater',
	'networkOperatorCmModuleAdmin',
	'networkOperatorAlarmManager',
	'smoLightViewer',
	'smoLightUpdater',
	'aiAccessToPmData',
	'defaultRole',
];
